import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ReactComponent as TeamIcon } from "../../../../../assets/images/People/Teams/team.svg";
import { ReactComponent as CreatedIcon } from "../../../../../assets/images/People/Teams/created.svg";
import { ReactComponent as AboutIcon } from "../../../../../assets/images/People/Teams/about.svg";
import { peopleDescriptionBodySx } from "../../peopleFormValidation";
import TeamDetailInfoField from "./TeamDetailInfoField";

const sectionCardSx = {
  width: "100%",
  maxWidth: 632,
  borderRadius: "8px",
  border: "1px solid #E5E9EC",
  background: "#FFF",
  p: 3,
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
};

export default function TeamDetailInfoSection({ team }) {
  return (
    <Box sx={{ mb: 3, minWidth: 0 }}>
      <Typography
        sx={{
          color: "#061522",
          fontFamily: "Inter",
          fontSize: 20,
          fontWeight: 500,
          lineHeight: "34px",
          mb: 1.5,
        }}
      >
       Information
      </Typography>
      <Box sx={sectionCardSx}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
            gap: 3,
            mb: 3,
            minWidth: 0,
          }}
        >
          <TeamDetailInfoField icon={TeamIcon} label="Team" value={team.name} />
          <TeamDetailInfoField icon={CreatedIcon} label="Created" value={team.createdDisplay} />
        </Box>

        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, minWidth: 0 }}>
          <Box sx={{ flexShrink: 0, lineHeight: 0, marginTop: "-2px" }}>
            <AboutIcon />
          </Box>
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography
              sx={{
                color: "#405261",
                fontFamily: "Inter",
                fontSize: 14,
                fontWeight: 400,
                lineHeight: "18px",
                mb: 1,
              }}
            >
              About
            </Typography>
            <Typography
              component="div"
              sx={{
                color: "#061522",
                fontFamily: "Inter",
                fontSize: 16,
                fontWeight: 400,
                lineHeight: "18px",
                ...peopleDescriptionBodySx,
              }}
            >
              {team.description || "—"}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
